module.exports = __webpack_public_path__ + "img/wallpaper.bf33b36b.jpg";